"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _getRgbaFromHex = _interopRequireDefault(require("../../utils/getRgbaFromHex"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

var Modal = {
  styles: function styles(theme) {
    return {
      defaultModalBoxStyles: {
        background: theme.colors.pageBackground,
        borderColor: theme.colors.baseContrast015,
        borderRadius: 12,
        padding: theme.spacing.base * 3,
        boxShadow: "".concat((0, _getRgbaFromHex.default)(theme.colors.baseShadow, 0.5), " 0 2px 4px 0"),
        borderImageSource: "none"
      },
      small: {
        width: 288,
        padding: theme.spacing.base * 3
      },
      medium: {
        width: 560
      },
      defaultCloseButtonStyles: {
        backgroundColor: (0, _getRgbaFromHex.default)(theme.colors.baseShadow, 0.15),
        borderRadius: "100%",
        width: theme.spacing.base * 4,
        height: theme.spacing.base * 4,
        minHeight: theme.spacing.base * 4,
        minWidth: theme.spacing.base * 4,
        "&:hover": {
          backgroundColor: (0, _getRgbaFromHex.default)(theme.colors.baseShadow, 0.2)
        },
        "& svg": {
          fill: theme.colors.baseContrast100,
          width: 18,
          height: 18,
          minHeight: 18,
          minWidth: 18
        }
      }
    };
  }
};
var _default = exports.default = Modal;